var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_497_5124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 5.02344V11.3334C14.6667 11.8436 14.4718 12.3344 14.1218 12.7056C13.7718 13.0768 13.2933 13.3002 12.784 13.3301L12.6667 13.3334H3.33334C2.8232 13.3335 2.33233 13.1386 1.96117 12.7886C1.59001 12.4386 1.36661 11.96 1.33668 11.4508L1.33334 11.3334V5.02344L7.63001 9.22144L7.70734 9.26544C7.79848 9.30997 7.89858 9.33311 8.00001 9.33311C8.10144 9.33311 8.20154 9.30997 8.29268 9.26544L8.37001 9.22144L14.6667 5.02344Z",
    fill: "#9948FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 2.66699C13.3867 2.66699 14.018 3.04699 14.37 3.61833L8.00001 7.86499L1.63 3.61833C1.79716 3.34684 2.02681 3.11926 2.29981 2.95458C2.57281 2.7899 2.88123 2.6929 3.19934 2.67166L3.33334 2.66699H12.6667Z",
    fill: "#9948FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_497_5124"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mailIcon.5dec319b928a3450357de22b27d03f6f.svg";
export { ForwardRef as ReactComponent };